export default __webpack_public_path__ + "static/media/writer.d5062b21.svg";